/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = [`admin`, `editor`];
  return valid_map.indexOf(str.trim()) >= 0;
}

/**
 * @param {string} url
 * @returns {Boolean}
 */
export function validURL(url) {
  const reg =
    /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
  return reg.test(url);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validLowerCase(str) {
  const reg = /^[a-z]+$/;
  return reg.test(str);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUpperCase(str) {
  const reg = /^[A-Z]+$/;
  return reg.test(str);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validAlphabets(str) {
  const reg = /^[A-Za-z]+$/;
  return reg.test(str);
}

// 数值类型可以为负数
export function isNumeric(value) {
  const values = Number(value);
  return /^-?\d+(\.\d+)?$/.test(values);
}

// 数值类型不能为负数
export function isValidNumber(value) {
  return /^\d+(\.\d+)?$/.test(value);
}

/**
 * @param {string} email
 * @returns {Boolean}
 */
export function validEmail(email) {
  const reg =
    /^(([^<>()\[\]\\.,;:\s@`]+(\.[^<>()\[\]\\.,;:\s@`]+)*)|(`.+`))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return reg.test(email);
}
/**
 * @param {string} mobile
 * @returns {Boolean}
 */
export function validMobile(mobile) {
  const reg = /^1\d{10}$/;
  return reg.test(mobile);
}

// 验证15位的数字+ 字母
export function validString(string) {
  const reg = /^[A-Za-z0-9]{15}$/;
  return reg.test(string);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
  if (typeof str === `string` || str instanceof String) {
    return true;
  }
  return false;
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray(arg) {
  if (typeof Array.isArray === `undefined`) {
    return Object.prototype.toString.call(arg) === `[object Array]`;
  }
  return Array.isArray(arg);
}

// 校验密码 8位以上非纯数字 /^(?![a-zA-Z]+$)^(?![0-9]+$)^(?![^a-zA-Z0-9]+$)[\x1f-~]{8,}$/
export const validPassword = (password) =>
  /^(?![a-zA-Z]+$)^(?![a-z0-9]+$)^(?![0-9A-Z]+$)^(?![0-9]+$)^(?![^a-zA-Z0-9]+$)[\x1f-~]{8,}$/.test(
    password
  );

export const validatePassword = (rule, value, callback) => {
  if (validPassword(value)) {
    callback();
  } else {
    callback(new Error(`请输入8位以上含3种字符密码`));
  }
};
export const validateTelephone = (rule, value, callback) => {
  if (/\S{6,}$/.test(value)) {
    callback();
  } else {
    callback(new Error(`请输入6位以上固话`));
  }
};
export const validateFax = (rule, value, callback) => {
  if (/\S{6,}$/.test(value)) {
    callback();
  } else {
    callback(new Error(`请输入6位以上传真`));
  }
};

export const validateEmail = (rule, value, callback) => {
  if (validEmail(value)) {
    callback();
  } else {
    callback(new Error(`邮箱不正确`));
  }
};
export const validateMobile = (rule, value, callback) => {
  if (validMobile(value)) {
    callback();
  } else {
    callback(new Error(`手机号不正确`));
  }
};

export const validatePhoneNumber = (rule, value, callback) => {
  const reg = /^1[3-9]\d{9}$/; // 中国大陆手机号码正则表达式
  if (reg.test(value)) {
    callback();
  } else {
    callback(new Error(`请输入有效的手机号码`));
  }
};

export const validateNewPassword = (rule, value, callback) => {
  var reg1 =
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*?._])[A-Za-z\d!@#$%^&*?._]{8,}$/; //密码必须是8位以上、必须含有字母、数字、特殊符号
  // var reg2 = /(123|234|345|456|567|678|789|012)/; //不能有3个连续数字
  if (!reg1.test(value)) {
    callback(new Error(`密码必须是8位以上、必须含有字母、数字、特殊符号`));
  } else {
    callback();
  }
};

// 判断输入值是否为空
const isEmpty = (val) => val === undefined || val === null || val === "";

// 判断非空逻辑
const isNotEmpty = (val) => val !== undefined && val !== null && val !== "";

// 判空
export const validateIsEmpty = (rule, value, callback) => {
  let keyList = rule.split("-");
  if(keyList[0].includes('数据中心') && value == null){
    callback();
  }
  if (isEmpty(value)) {
    callback(new Error(`${keyList[0]}不能为空`));
  } else {
    callback();
  }
};

// 判断为数字类型
export function validateIsNumeric(rule, value, callback) {
  let keyList = rule.split("-");
  if (!isEmpty(value)) {
    if (!isValidNumber(value)) {
      callback(new Error(`${keyList[0]}必须为数字类型`));
    } else {
      callback();
    }
  } else {
    callback(new Error(`${keyList[0]}不能为空`));
  }
}

// 判断为字符串
export function validateString(rule, value, callback) {
  let keyList = rule.split("-");
  if (!validString(value) || isEmpty(value)) {
    callback(new Error(`${keyList[0]}必须为数字或字母类型`));
  } else {
    callback();
  }
}

// 判断是否为正数百分数
export const validatePerCent = (rule, value, callback) => {
  let keyList = rule.split(`-`);
  const reg = /^(100(\.00?)?|[1-9]?[0-9](\.[0-9]{1,2})?)%$/;
  if (
    rule == `门户网站IPv6支持率（%）-${keyList[1]}` ||
    rule == `面向公众的互联网应用系统IPv6支持率（%）-${keyList[1]}` ||
    rule ==
      `面向机构内部网络（办公网、数据中心内部）IPv6部署覆盖率（%）-${keyList[1]}` ||
    rule == `如是，开源技术应用、治理相关专职/兼职人员，占本单位科技条线总人员的总体比例（见填写说明3）-${keyList[1]}`
  ) {
    if (reg.test(value)) {
      callback();
    } else {
      callback(new Error(`${keyList[0]}必须为[0%,100%]之间`));
    }
  } else {
    callback();
  }
};

// 验证数字类型并且小于500000数据规模
export function validataSize(rule, value, callback) {
  let keyList = rule.split("-");
  if (!isValidNumber(value) || isEmpty(value) || value > 500000) {
    callback(new Error(`${keyList[0]}必须为数字类型并且<=500000`));
  } else {
    callback();
  }
}

// 验证外部数据应用项目数量
export function valiExternalProjects(rule, value, callback, data) {
  let keyList = rule.split(`-`);
  console.log('data==>',data,keyList[1])
  let values =
    data[`表3-3-1 数据应用资源投入情况`][keyList[1]][
      `其中，公共数据类应用项目数量（个）-${keyList[1]}`
    ] || 0;
  if (
    !isValidNumber(value) ||
    isEmpty(value) ||
    Number(value) < Number(values)
  ) {
    callback(
      new Error(`${keyList[0]}必须为数字类型并且>=公共数据类应用项目数量`)
    );
  } else {
    callback();
  }
}

// 金融科技投入情况
export function valiInvestmentSituation(rule, value, callback, data) {
  let keyList = rule.split(`-`);
  let tableName = "表2-1-2 金融科技投入情况";
  if (isNumeric(value) && isNotEmpty(value)) {
    if (rule == `总资产（亿元）-${keyList[1]}`) {
      let values =
        data[tableName][keyList[1]][`营业收入（万元）-${keyList[1]}`] || 0;
      if (Number(value) <= 500000 && value * 10000 > values) {
        callback();
      } else {
        callback(
          new Error(
            `${keyList[0]}必须为数字类型并且<=500000(亿)且>营业收入（万元）`
          )
        );
      }
    }
    if (rule == `营业收入（万元）-${keyList[1]}`) {
      let values =
        data[tableName][keyList[1]][`总资产（亿元）-${keyList[1]}`] || 0;
      if (Number(value) < Number(values * 10000)) {
        callback();
      } else {
        callback(new Error(`${keyList[0]}必须为数字类型并且<总资产`));
      }
    }
    // if (rule == `金融科技投入（万元）-${keyList[1]}`) {
    //   let values =
    //     data[tableName][keyList[1]][`营业收入（万元）-${keyList[1]}`] || 0;
    //   if (Number(value) < Number(values)) {
    //     callback();
    //   } else {
    //     callback(new Error(`${keyList[0]}必须为数字类型并且<营业收入`));
    //   }
    // }
  } else {
    callback(new Error(`${keyList[0]}是必填项且为数字类型`));
  }
}

// 校验算力总规模
export function validateComputeScope(rule, value, callback, data) {
  let keyList = rule.split("-");
  let tableName = "表4-3-1 算力建设情况";
  if (isValidNumber(value) || isNotEmpty(value)) {
    if (rule == `算力总规模（PFLOPS[FP32]）注：按照FP32口径进行统计-${keyList[1]}`) {
      let value1 =
        Number(
          data[tableName][keyList[1]][
            `其中，通用算力规模（PFLOPS[FP32]）-${keyList[1]}`
          ]
        ) || 0;
      let value2 =
        Number(
          data[tableName][keyList[1]][
            `其中，新型算力规模（PFLOPS[FP32]）-${keyList[1]}`
          ]
        ) || 0;
      if (Number(value) != value1 + value2) {
        callback(
          new Error(`${keyList[0]} = 【通用算力规模】 + 【新型算力规模】`)
        );
      } else {
        callback();
      }
    }
    if (
      rule ==
      `其中，支撑大模型应用配备的加速卡的型号及数量，包含训练、推理。（单位：卡）-${keyList[1]}`
    ) {
      let value1 =
        Number(
          data[tableName][keyList[1]][
            `其中，昇腾910B数量（单位：卡）-${keyList[1]}`
          ]
        ) || 0;
      let value2 =
        Number(
          data[tableName][keyList[1]][
            `其中，海光DCU数量（单位：卡）-${keyList[1]}`
          ]
        ) || 0;
      let value3 =
        Number(
          data[tableName][keyList[1]][
            `其中，NVIDIA Tesla V100数量（单位：卡）-${keyList[1]}`
          ]
        ) || 0;
      let value4 =
        Number(
          data[tableName][keyList[1]][
            `其中，NVIDIA Tesla A100数量（单位：卡）-${keyList[1]}`
          ]
        ) || 0;
      let value5 =
        Number(
          data[tableName][keyList[1]][
            `其中，NVIDIA Tesla A800数量（单位：卡）-${keyList[1]}`
          ]
        ) || 0;
      let value6 =
        Number(
          data[tableName][keyList[1]][`其他型号数量（单位：卡）-${keyList[1]}`]
        ) || 0;
      let allValue = value1 + value2 + value3 + value4 + value5 + value6;
      if (Number(value) == allValue) {
        callback();
      } else {
        callback(
          new Error(
            `${keyList[0]} = 【昇腾910B数量】+【海光DCU数量】+【NVIDIA Tesla V100】+【NVIDIA Tesla A100】+【NVIDIA Tesla A800】+【其他型号数量】`
          )
        );
      }
    }
  } else {
    callback(new Error(`${keyList[0]}必须为数字类型`));
  }
}

// 校验系统总数量
export function validateSystemNum(rule, value, callback, data) {
  let keyList = rule.split(`-`);
  let values =
    data[`表4-3-2 云计算应用部署建设情况`][keyList[1]][
      `上私有云系统数量（个）-${keyList[1]}`
    ] || 0;
  if (
    !isValidNumber(value) ||
    isEmpty(value) ||
    Number(value) < Number(values)
  ) {
    callback(new Error(`${keyList[0]}必须为数字类型并且>=上私有云系统数量`));
  } else {
    callback();
  }
}

// 校验应用项目数量
export function validateApplySystemNum(rule, value, callback, data) {
  let keyList = rule.split(`-`);
  let tableName = "表5-1 金融科技应用项目数量";
  if (isValidNumber(value) && isNotEmpty(value)) {
    if (rule == `量子技术应用项目数量（个）-${keyList[1]}`) {
      let values =
        Number(
          data[tableName][keyList[1]][
            `其中，抗量子密码技术应用研究案例数量（个）-${keyList[1]}`
          ]
        ) || 0;
      if (Number(value) < values) {
        callback(new Error(`${keyList[0]}>=抗量子密码技术应用研究案例数量`));
      } else {
        callback();
      }
    }

    if (rule == `人工智能项目数量（个）-${keyList[1]}`) {
      let values =
        Number(
          data[tableName][keyList[1]][
            `其中，使用大模型信息系统数量（个）-${keyList[1]}`
          ]
        ) || 0;
      if (Number(value) < values) {
        callback(new Error(`${keyList[0]}>=使用大模型信息系统数量`));
      } else {
        callback();
      }
    }

    if (rule == `项目总数量（个）-${keyList[1]}`) {
      let val1 =
        Number(
          data[tableName][keyList[1]][`大数据应用项目数量（个）-${keyList[1]}`]
        ) || 0;
      let val2 =
        Number(
          data[tableName][keyList[1]][`云计算应用项目数量（个）-${keyList[1]}`]
        ) || 0;
      let val3 =
        Number(
          data[tableName][keyList[1]][`卫星通信应用项目数量（个）-${keyList[1]}`]
        ) || 0;
      let val4 =
        Number(
          data[tableName][keyList[1]][
            `分布式数据库应用项目数量（个）-${keyList[1]}`
          ]
        ) || 0;
      let val5 =
        Number(
          data[tableName][keyList[1]][
            `多元身份认证应用项目数量（个）-${keyList[1]}`
          ]
        ) || 0;
      let val6 =
        Number(
          data[tableName][keyList[1]][`分布式账本应用项目数量（个）-${keyList[1]}`]
        ) || 0;
      let val7 =
        Number(
          data[tableName][keyList[1]][`物联网应用项目数量（个）-${keyList[1]}`]
        ) || 0;
      let val8 =
        Number(data[tableName][keyList[1]][`5G应用项目数量（个）-${keyList[1]}`]) ||
        0;
      let val9 =
        Number(
          data[tableName][keyList[1]][`量子技术应用项目数量-${keyList[1]}`]
        ) || 0;
      let val10 =
        Number(
          data[tableName][keyList[1]][
            `其中，后量子密码技术项目数量（个）-${keyList[1]}`
          ]
        ) || 0;
      if (
        Number(value) < val1 ||
        Number(value) < val2 ||
        Number(value) < val3 ||
        Number(value) < val4 ||
        Number(value) < val5 ||
        Number(value) < val6 ||
        Number(value) < val7 ||
        Number(value) < val8 ||
        Number(value) < val9 ||
        Number(value) < val10
      ) {
        callback(new Error(`${keyList[0]}>=任何一个分项的数量`));
      } else {
        callback();
      }
    }
  } else {
    callback(new Error(`${keyList[0]}为必填项且为数字类型`));
  }
}

// 校验数据库应用情况
export function validateDataBaseDeploy(rule, value, callback, data) {
  let keyList = rule.split(`-`);
  let tableName =keyList[1].includes('生产系统') ?"表5-2-1 生产系统数据库部署及创新应用情况":"表5-2-2 备份系统数据库部署及创新应用情况";

  if (isValidNumber(value) && isNotEmpty(value)) {
    if (rule == `实例总数-${keyList[1]}`) {
      let val1 =
        Number(
          data[tableName][keyList[1]][`数据处理-集中式实例数-${keyList[1]}`]
        ) || 0;
      let val2 =
        Number(
          data[tableName][keyList[1]][`数据处理-分布式实例数-${keyList[1]}`]
        ) || 0;
      let val3 =
        Number(
          data[tableName][keyList[1]][
            `负载类型-交易型（OLTP）-${keyList[1]}`
          ]
        ) || 0;
      let val4 =
        Number(
          data[tableName][keyList[1]][
            `负载类型-分析型（OLAP）-${keyList[1]}`
          ]
        ) || 0;
      let val5 =
        Number(
          data[tableName][keyList[1]][
            `负载类型-混合负载型（HTAP）-${keyList[1]}`
          ]
        ) || 0;
      let val6 =
        Number(
          data[tableName][keyList[1]][`存储模式-存算一体实例数-${keyList[1]}`]
        ) || 0;
      let val7 =
        Number(
          data[tableName][keyList[1]][
            `存储模式-存算分离-集中式实例数-${keyList[1]}`
          ]
        ) || 0;
      let val8 =
        Number(
          data[tableName][keyList[1]][
            `存储模式-存算分离-分布式实例数-${keyList[1]}`
          ]
        ) || 0;
      let val9 =
        Number(
          data[tableName][keyList[1]][`已上云的数据库实例数量-${keyList[1]}`]
        ) || 0;
      if (Number(value) < (val1 + val2)) {
        callback(
          new Error(`${keyList[0]}>=集中式数据库实例数量+分布式数据库实例数量`)
        );
      } else if (Number(value) < (val3 + val4 + val5)) {
        callback(
          new Error(
            `${keyList[0]}>=交易型数据库（OLTP）实例数量+分析型数据库（OLAP）实例数量+混合负载型数据库（HTAP）实例数量`
          )
        );
      } else if (Number(value) < val9) {
        callback(new Error(`${keyList[0]}>=云数据库产品实例数量 `));
      } else if (Number(value) < (val7 + val8 + val6)) {
        callback(
          new Error(
            `${keyList[0]}>=存算一体+存算分离（集中式）+存算分离（分布式）`
          )
        );
      } else {
        callback();
      }
    }
    // if (rule == `部署架构分类—集中式数据库实例数量-${keyList[1]}`) {
    //   let val1 =
    //     Number(
    //       data[tableName][keyList[1]][
    //         `数据模型分类—关系型数据库实例数量-${keyList[1]}`
    //       ]
    //     ) || 0;
    //   let val2 =
    //     Number(
    //       data[tableName][keyList[1]][
    //         `数据模型分类—非关系型数据库实例数量-${keyList[1]}`
    //       ]
    //     ) || 0;
    //   if (Number(value) < val1 + val2) {
    //     callback(
    //       new Error(
    //         `${keyList[0]}>=关系型数据库实例数量+非关系型数据库实例数量`
    //       )
    //     );
    //   } else {
    //     callback();
    //   }
    // }
  } else {
    callback(new Error(`${keyList[0]}不为空且为数字类型`));
  }
}

// 校验手机app数量 || 员工数量
export function validateDataNum(rule, value, callback, data) {
  let keyList = rule.split(`-`);
  if (value == null) {
    callback(new Error(`${keyList[0]}必须为数字类型`));
  }
  if (isValidNumber(value) && isNotEmpty(value)) {
    if (rule == `手机APP数量（个）-${keyList[1]}`) {
      let val =
        Number(
          data[`表7-6-1 金融服务无障碍改造情况`][keyList[1]][
            `其中，无障碍手机APP数量（个）-${keyList[1]}`
          ]
        ) || 0;
      if (Number(value) < val) {
        callback(new Error(`${keyList[0]}>=【无障碍手机APP数量】`));
      } else {
        callback();
      }
    }
    if (rule == `员工总数（人）-${keyList[1]}`) {
      let val =
        Number(
          data[`表9-1 人才培养情况`][keyList[1]][
            `金融科技人员数量（人）-${keyList[1]}`
          ]
        ) || 0;
      if (Number(value) < val) {
        callback(new Error(`${keyList[0]}>=【金融科技人员数量】`));
      } else {
        callback();
      }
    }
  } else {
    callback(new Error(`${keyList[0]}为必须填且为数字类型`));
  }
}

export function validateListingRate(rule, value, callback) {
  let keyList = rule.split(`-`);
  if (value == null) {
    callback();
  }
  if (isValidNumber(value) || isNotEmpty(value)) {
    const reg = /%$/;
    if (reg.test(value)) {
      callback();
    } else {
      callback(new Error(`${keyList[0]}必须以%结尾`));
    }
  } else {
    callback();
  }
}

export function validateAddress(rule, value, callback) {
  let keyList = rule.split(`-`);
  if (value == null) {
    callback();
  }
  if (isNotEmpty(value)) {
    const provinceRegex =
      /^(?:河北省|山西省|辽宁省|吉林省|黑龙江省|江苏省|浙江省|安徽省|福建省|江西省|山东省|河南省|湖北省|湖南省|广东省|海南省|四川省|贵州省|云南省|陕西省|甘肃省|青海省|台湾省|内蒙古自治区|广西壮族自治区|西藏自治区|宁夏回族自治区|新疆维吾尔自治区|北京市|天津市|上海市|重庆市)$/;
    if (provinceRegex.test(value)) {
      callback();
    } else {
      callback(
        new Error(`${keyList[0]}必须为数据中心所处的省、直辖市或自治区的名称`)
      );
    }
  } else {
    callback();
  }
}

// 校验不能为空
export function validateIsempty(rule, value, callback, data) {
  let keyList = rule.split(`-`);
  if (isNotEmpty(value)) {
    callback();
  } else {
    callback(new Error(`${keyList[1]}必须为必填项`));
  }
}

// 判断为数值并不为空
export function validateIsemptys(rule, value, callback, data) {
  console.log("rule==>", rule);
  let keyList = rule.split(`-`);
  if (value == null) {
    callback();
  }
  if (isNotEmpty(value)) {
    if (isValidNumber(value)) {
      callback();
    } else {
      callback(new Error(`${keyList[1]}必须为数值`));
    }
  } else {
    callback(new Error(`${keyList[0]}必须为数值并且不能为空`));
  }
}

export function validatePcTransaction(rule, value, callback, data) {
  let keyList = rule.split("-");
  const tableName = "表7-3-3 各渠道交易情况";
  if (isValidNumber(value) || isNotEmpty(value)) {
    let val3 =
      Number(
        data[tableName][keyList[1]][`PC渠道交易量（万笔）-${keyList[1]}`]
      ) || 0;
    let val1 =
      Number(
        data[tableName][keyList[1]][`手机渠道交易量（万笔）-${keyList[1]}`]
      ) || 0;
    let val2 =
      Number(
        data[tableName][keyList[1]][`其他渠道交易量（万笔）-${keyList[1]}`]
      ) || 0;

    if (Number(value) == val1 + val2 + val3) {
      callback();
    } else {
      callback(
        new Error(
          `${keyList[0]} =【PC渠道交易量】 + 【手机渠道交易量】 + 【其他渠道交易量】 `
        )
      );
    }
  } else {
    callback(new Error(`${keyList[0]}必须为数值并且不能为空`));
  }
}

export function validateLevel(rule, value, callback) {
  if (value == null) {
    callback();
  }
  if (isNotEmpty(value)) {
    console.log("vale==>", value);
  } else {
    callback();
  }
}

// 校验产权状况
export function validateProperty(rule, value, callback) {
  let keyList = rule.split(`-`);
  const VALID_PATTERN = /^[abAB]+$/;
  if (keyList[0].includes("数据中心") && value == null) {
    callback();
  } else {
    if (isNotEmpty(value)) {
      if (VALID_PATTERN.test(value)) {
        callback();
      } else {
        callback(new Error(`${keyList[1]}必须为a,b,A,B`));
      }
    } else {
      callback(new Error(`${keyList[0]}不能为空`));
    }
  }
}

// 人工智能专项投入校验
export function validateArtificialIntelligenceInvestment(
  rule,
  value,
  callback,
  data
) {
  let keyList = rule.split(`-`);
  const tableName = "表6-1 人工智能投入情况";
  console.log(keyList[0], keyList[1]);
  if (isValidNumber(value) && isNotEmpty(value)) {
    let val1 =
      Number(
        data[tableName][keyList[1]][
          `其中，算力基础设施投入（万元）-${keyList[1]}`
        ]
      ) || 0;
    let val2 =
      Number(
        data[tableName][keyList[1]][
          `其中，大模型研发及采购投入（万元）（见填写说明3）-${keyList[1]}`
        ]
      ) || 0;

    // let val3 =
    //   Number(
    //     data[tableName][keyList[1]][
    //       `其中：AI应用开发投入（万元）-${keyList[1]}`
    //     ]
    //   ) || 0;
    // let val4 =
    //   Number(
    //     data[tableName][keyList[1]][
    //       `其中：AI人才相关投入（万元）-${keyList[1]}`
    //     ]
    //   ) || 0;
    // console.log(val1, val2, val3, val4, value);
    if (Number(value) < val1 + val2 ) {
      callback(
        new Error(
          `${keyList[0]+'-'+keyList[1]}>=算力基础设施投入（万元）-${
            keyList[1]
          } + 大模型研发及采购投入（万元）-${
            keyList[1]
          }
          }`
        )
      );
    } else {
      callback();
    }
  } else {
    callback(new Error(`${keyList[0] +'-'+ keyList[1]}必须为数值并且不能为空`));
  }
}
